import { useThemeStore } from "@stores/theme.store";
import { Select } from "antd";
import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { SchoolService } from "@services/school.service";
import { Spiner } from "@components/loaders/spiner";
import { FcFinePrint } from "react-icons/fc";
// moment.locale("id");
export const ReportCardFinalExamPage = () => {
  const { setHeader, setAppBar } = useThemeStore((state) => state);
  const [semester, setSemester] = useState<string>("1");
  const [type, setType] = useState<string>("PTS");

  const { data: dataNis } = useQuery({
    queryKey: [SchoolService.queries.GET_SCHOOL_STUDENT_BIO],
    queryFn: SchoolService.studentBio,
  });
  const nis = dataNis?.data?.nis ?? "";

  const { data, isPending } = useQuery({
    queryKey: [
      SchoolService.queries.GET_SCHOOL_STUDENT_FINAL_SCORES,
      nis,
      semester,
      type,
    ],
    queryFn: () => SchoolService.studentFinalScores({ nis, semester, type }),
  });

  useEffect(() => {
    setAppBar({ title: "Nilai Ujian Semester", show: true, leading: "back" });
    setHeader({
      buttonBack: true,
      filter: false,
      title: "Nilai Ujian Semester",
    });
  }, [setHeader, setAppBar]);

  return (
    <>
      <div className="tw-px-4 tw-pb-20">
        <>
          <div className="tw-bg-other-100 tw-rounded-lg card-body">
            <div className="tw-text-xs tw-mb-1">
              Pilih Jenis Ujian dan Semester
            </div>
            <Select
              className="tw-border-other-0 tw-text-base"
              placeholder="Pilih Jenis Ujian"
              defaultValue={type}
              style={{ width: "100%" }}
              allowClear
              onChange={(e) => setType(e)}
              options={[
                { value: "PTS", label: "PTS" },
                { value: "PAS", label: "PAS" },
              ]}
            ></Select>
            <Select
              className="tw-border-other-0 tw-text-base tw-mt-3"
              placeholder="Pilih Semester"
              defaultValue={semester}
              style={{ width: "100%" }}
              allowClear
              onChange={(e) => setSemester(e)}
              options={[
                { value: "1", label: "1" },
                { value: "2", label: "2" },
              ]}
            ></Select>
            <p className="tw-mt-3 tw-text-sm">
              Data yang ditampilkan: {type} {semester}
            </p>
          </div>

          <div className="tw-bg-other-100 tw-rounded-lg card-body tw-mt-3">
            {isPending ? (
              <div className="tw-text-center">
                <Spiner />
              </div>
            ) : data?.message === "hidden" ? (
              <div className="tw-p-8 tw-text-center">
                <FcFinePrint size={50} />
                <div>Nilai belum bisa ditampilkan</div>
              </div>
            ) : data?.data != null && data.data.length > 0 ? (
              <div>
                <div className="tw-flex tw-justify-between tw-items-start tw-font-semibold">
                  <div className="tw-w-2/4 tw-flex tw-justify-around">
                    <div className="tw-text-sm">Mata Pelajaran</div>
                  </div>
                  <div className="tw-w-1/4 tw-flex tw-justify-around">
                    <div className="tw-text-sm">Nilai KKM</div>
                  </div>
                  <div className="tw-w-1/4 tw-flex tw-justify-around">
                    <div className="tw-text-sm">Nilai</div>
                  </div>
                </div>
                {data.data.map((item, idx) => (
                  <div
                    key={idx}
                    className="tw-border-solid tw-border-x-0 tw-border-y-1 tw-border-y-other-200 tw-py-1 tw-mb-0.5"
                  >
                    <div className="tw-flex tw-justify-between tw-items-start tw-font-semibold">
                      <div className="tw-w-2/4 tw-flex tw-justify-between">
                        <div
                          className="tw-text-sm"
                          style={{
                            overflowWrap: "break-word",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {item.namamapel}
                        </div>
                      </div>
                      <div className="tw-w-1/4 tw-flex tw-justify-around">
                        <div className="tw-text-sm">{item.nilaikkm}</div>
                      </div>
                      <div className="tw-w-1/4 tw-flex tw-justify-around">
                        <div className="tw-text-sm">{item.nilai ?? "-"}</div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="tw-p-8 tw-text-center">
                <FcFinePrint size={50} />
                <div>Data tidak ditemukan</div>
              </div>
            )}
          </div>
        </>
      </div>
    </>
  );
};
